import React, { useMemo } from 'react'
import { Button, Modal, Typography } from 'antd'
import { useIntl } from 'react-intl'

const { Paragraph } = Typography

const PaymentGatewayDismissWarningModal = ({
  open,
  onCancel,
  onActivate,
  notificationId,
  activateLoading = false,
}) => {
  const { formatMessage } = useIntl()

  const footer = useMemo(
    () => [
      <Button
        key="activate"
        type="primary"
        loading={activateLoading}
        disabled={activateLoading}
        onClick={() => {
          if (notificationId && !activateLoading) {
            onActivate?.(notificationId)
          }
        }}
      >
        {formatMessage({ id: 'appOnboarding.paymentGateway.btn_activate_payment_connect' })}
      </Button>,
      <Button key="decline" danger disabled={activateLoading} onClick={onCancel}>
        {formatMessage({ id: 'appOnboarding.paymentGateway.btn_do_not_activate' })}
      </Button>,
    ],
    [activateLoading, formatMessage, notificationId, onActivate, onCancel],
  )

  return (
    <Modal
      open={open}
      title={formatMessage({ id: 'appOnboarding.paymentGateway.dismiss_modal_title' })}
      onCancel={onCancel}
      closable={!activateLoading}
      footer={footer}
      maskClosable={false}
      keyboard={false}
      destroyOnHidden
      width={480}
    >
      <Paragraph style={{ marginBottom: 0 }}>
        {formatMessage({ id: 'appOnboarding.paymentGateway.dismiss_warning_title' })}
      </Paragraph>
    </Modal>
  )
}

export default PaymentGatewayDismissWarningModal
